import React, {Component} from 'react';

import {connect} from "react-redux";
import {PropTypes} from "prop-types";
import SelectBox from "../../../etc/SelectBox"

import {bindActionCreators} from "redux";
import * as Actions from "../../../../store/modules/journals";
import * as FActions from "../../../../store/modules/footer";
import {
	getObjectLength,
	objectToQueryString,
	pushUrl,
	getNumberFormat,
	getSelectFormat
} from "../../../../utils/functions"

import {BASE_PATH, JOURNAL_FACET_NAME, FACET_ORDER} from "../../../../wpconfig"

import * as func from "../../../../utils/functions";

class JournalFacet extends Component {
	constructor(props) {
		super(props);
	}

	argsInputTextEvnet = (event) => {
		const {dataActions} = this.props;
		let param = this.props.param;
		param[event.target.name] = event.target.value;
		dataActions.setJournals({"param": param});

		if (event.key === "Enter") {
			setTimeout(() => {
				func.getData("journals", this.props.param).then((response) => {
					this.props.dataActions.setJournals(response);

					const url = objectToQueryString(this.props.param);
					pushUrl('검색', BASE_PATH + 'journals/?' + url, this.props.param);
				});
			}, 0);
		}
	}

	facetChangeEvent = (event) => {
		if (event.target.type === "checkbox") {
			let param = this.props.param;
			if (event.target.checked) {
				if (param[event.target.name].indexOf(event.target.value) < 0) {
					param[event.target.name].push(event.target.value);
				}
			} else {
				if (param[event.target.name].indexOf(event.target.value) > -1) {
					param[event.target.name].splice(param[event.target.name].indexOf(event.target.value), 1);
				}
			}
			const {dataActions} = this.props;
			dataActions.setJournals({"param": param});

			func.getData("journals", param).then((response) => {
				this.props.dataActions.setJournals(response);

				const url = objectToQueryString(param);
				pushUrl('검색', BASE_PATH + 'journals/?' + url, param);
			});
		} else if (event.target.type === "button") {
			let param = this.props.param;
			if (param[event.target.name].indexOf(event.target.value) < 0) {
				param[event.target.name].push(event.target.value);
			}
			const {dataActions} = this.props;
			dataActions.setJournals({"param": param});

			func.getData("journals", param).then((response) => {
				this.props.dataActions.setJournals(response);

				const url = objectToQueryString(param);
				pushUrl('검색', BASE_PATH + 'journals/?' + url, param);
			});
		}
	}

	facetChangeEventOnly = (event) => {
		if (event.target.type === "checkbox") {
			let param = this.props.param;
			if (event.target.checked) {
				param[event.target.name] = event.target.value;
			} else {
				param[event.target.name] = '';
			}
			const {dataActions} = this.props;
			dataActions.setJournals({"param": param});

			func.getData("journals", param).then((response) => {
				this.props.dataActions.setJournals(response);

				const url = objectToQueryString(param);
				pushUrl('검색', BASE_PATH + 'journals/?' + url, param);
			})
		}
	}

	facetReset = (event) => {
		let param = this.props.param;
		Object.keys(this.props.param).map((key, i) => {
			if (!param[key] || param[key].length <= 0)
				return;
			if (key === 'records_per_page' || key === 'order' || key === 'orderby') {
			} else if (key === 'current_page') {
				param[key] = 1;
			} else if (Array.isArray(param[key])) {
				param[key] = [];
			} else {
				param[key] = "";
			}
		});

		const {dataActions} = this.props;
		dataActions.setJournals({"param": param});
		func.getData("journals", this.props.param).then((response) => {
			this.props.dataActions.setJournals(response);

			pushUrl('검색', BASE_PATH + 'journals/', null);
		});
	}

	search = (event) => {
		func.getData("journals", this.props.param).then((response) => {
			this.props.dataActions.setJournals(response);

			const url = objectToQueryString(this.props.param);
			pushUrl('검색', BASE_PATH + 'journals/?' + url, this.props.param);
		});
	}

	tabAction = (event) => {
		event.target.parentNode.classList.toggle('active');
	}

	morePopup = (type) => {
		this.props.fDataActions.setFooter({
			'isPopup1': !this.props.isPopup1,
			'type': type,
			'part' : 'journals'
		});
	}

	render() {
		const facets = getObjectLength(this.props.facet) > 0 ? FACET_ORDER : [];
		const param = this.props.param;
		const totalRecords = this.props.totalRecords;

		return (
			<div className="left-side-group">
				<div className="d-flex align-items-center justify-content-between mb-28">
					<h3 className="con-title">패싯 검색</h3>
					<div className="d-flex">
						{/*<button type="button" className="btn-search-ui"><span className="icon icon-size-24 icon-plus-white" /></button>*/}
						{/*<button type="button" className="btn-search-ui ml-2"><span className="icon icon-size-24 icon-bookmark-white" /></button>*/}
						<button type="button" className="btn-search-ui ml-2" onClick={this.facetReset}><span
							className="icon icon-size-24 icon-refresh-white"/></button>
					</div>
				</div>
				{totalRecords > 0 &&
				<div className="">
					<div className="form-side-search border-none pt-0">
						<div className="form-title">결과내 검색</div>
						<div className="form-input">
							<div className="input-btn">
								<input type="text" name="sub_ks" defaultValue={param.sub_ks} onKeyUp={this.argsInputTextEvnet}
								       className="form-control" autoComplete="off"/>
								<button type="button" className="btn-control" onClick={this.search}><span
									className="icon icon-size-24 icon-search-gray"/></button>
							</div>
						</div>
					</div>
				</div>
				}
				{this.props.facet && getObjectLength(this.props.facet) > 0 ?
					facets.map((fa, i) => {
						const facet = this.props.facet[fa];
						if (!facet)
							return;
						if (fa === 'dept')
							facet.result = getSelectFormat(facet.result);
						return (
							<div key={i}>
								{fa === 'dept' ?
									<div className="form-side-search">
										<div className="form-title">학과 선택</div>
										<SelectBox
											name={fa}
											title="선택해주세요"
											isMulti
											onAdd={this.facetChangeEvent}
											onRemove={this.facetChangeEvent}
											OptionData={facet.result}
										/>
									</div>
									:
									<div className="form-side-search">
										<div className="form-tree-item active" onClick={this.tabAction}>
											<button type="button" className="btn-tree-nav">{JOURNAL_FACET_NAME[fa]}</button>
											<div className="detail-tree-item">
												<div className="vertical-checkbox-list mt-3">
													<div className="checkbox-group">
														<div className="checkbox-group-cell mb-2">
															{facet.result.length > 0 && facet.result.map((item, index) => {
																if ((fa !== 'registered_db_name' && fa !== 'journal_ranking') && index >= 5)
																	return;

																if(fa === 'journal_ranking') {
																	return item.result.map((sitem, i) => {

																		const v = item.name + '|' + sitem.name
																		const checked = this.props.param[fa] === v;

																		return (
																			<React.Fragment key={index + '_' + i}>
																				<div className="checkbox-group-cell mb-2" key={''+index + ' ' + i}>
																					<div className="custom-control custom-checkbox">
																						<input id={fa + '_' + index + '_' + i} name={fa} type="checkbox"
																						       className="custom-control-input"
																						       checked={checked} onChange={this.facetChangeEventOnly}
																						       value={v}/>
																						<label className="custom-control-label"
																						       htmlFor={fa + '_' + index + '_' + i}>{item.name + ' ' + sitem.name} ({getNumberFormat(sitem.count)})</label>
																					</div>
																				</div>
																			</React.Fragment>
																		)
																	});
																} else {
																	const checked = this.props.param[fa].includes(item.name);
																	return (
																		<React.Fragment key={index}>
																			<div className="checkbox-group-cell mb-2" key={index}>
																				<div className="custom-control custom-checkbox">
																					<input id={fa + '_' + index} name={fa} type="checkbox"
																					       className="custom-control-input"
																					       checked={checked} onChange={this.facetChangeEvent} value={item.name}/>
																					<label className="custom-control-label"
																					       htmlFor={fa + '_' + index}>{item.name} ({getNumberFormat(item.count)})</label>
																				</div>
																			</div>
																		</React.Fragment>
																	)
																}
															})}
														</div>
													</div>
													{((fa !== 'registered_db_name' && fa !== 'journal_ranking') && facet.result.length > 5) &&
													<div className="checkbox-more">
														<button type="button" className="btn-checkbox-more" onClick={() => this.morePopup(fa)}>
															<span className="icon icon-size-24 icon-plus-black mr-2 align-top"/>More
														</button>
													</div>
													}
												</div>
											</div>
										</div>
									</div>
								}
							</div>
						)
					})
					: ''
				}
			</div>
		)
	}
}

export default connect(
	(state) => ({
		totalRecords: state.journals.totalRecords ? state.journals.totalRecords : 0,
		facet: state.journals.facet ? state.journals.facet : {},
		param: state.journals.param ? state.journals.param : {},
		isPopup1: state.footer.isPopup1 ? state.footer.isPopup1 : false,
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(JournalFacet)

JournalFacet.propTypes = {
	param: PropTypes.object,
	facet: PropTypes.object,
};
